import React, { Component } from 'react';
import { Field } from 'redux-form';
import { intlShape, injectIntl } from 'react-intl';
import TextField from '../../../shared-components/TextField/TextField';
import { isEmpty, isValidDateOfBirth as isValidDateOfBirthHelper } from '../../../shared-components/FormElement/FormElementUtils';
import { connect } from 'react-redux';

const LOCALE_PREFIX = 'GB/components/DateOfBirth/DateOfBirth';

export const isValidDateOfBirth = (underAgeMsg, errorMsg) => (value) => {
    return isValidDateOfBirthHelper(value, 'DD/MM/YYYY', underAgeMsg, errorMsg);
};

export class TeslaDateOfBirth extends Component {
    static propTypes = {
        intl: intlShape.isRequired
    };

    render() {
        const { intl } = this.props;

        return (
            <Field
                id="dob"
                name="dob"
                type="tel"
                component={TextField}
                autoComplete="disabled"
                autoCorrect="off"
                autoCapitalize="off"
                placeholder={intl.formatMessage({id: `${LOCALE_PREFIX}.dobLabel-tesla`})}
                mask="99/99/9999"
                label={intl.formatMessage({id: `${LOCALE_PREFIX}.dobLabel-tesla`})}
                validate={[
                    isEmpty(intl.formatMessage({id: `${LOCALE_PREFIX}.DOB_REQUIRED`})),
                    isValidDateOfBirth(
                        intl.formatMessage({id: `${LOCALE_PREFIX}.DOB_ERROR`}),
                        intl.formatMessage({id: `${LOCALE_PREFIX}.DATE_INVALID`})
                    )
                ]}
            />
        );
    }
}

export default injectIntl(TeslaDateOfBirth);
